import React from "react";

const TICK_POSITIONS = [1, 2, 3, 4, 5, 6, 7, 8, 9];
const SCALE_NUMBERS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

export const SectionTitle = ({ icon: Icon, children, sub }) => (
  <div className="mb-4">
    <div className="flex items-center gap-2.5">
      {Icon && <Icon size={19} strokeWidth={2.2} className="text-[var(--ink)] shrink-0" />}
      <h2
        className="text-[var(--ink)] font-semibold uppercase leading-none"
        style={{ letterSpacing: "0.14em", fontSize: "0.98rem" }}
      >
        {children}
      </h2>
    </div>
    {sub && (
      <p className="text-[var(--muted)] text-xs uppercase tracking-widest mt-1.5 ml-[29px]">
        {sub}
      </p>
    )}
    <div className="mt-2 h-[3px] w-full bg-[var(--ink)] rounded-full" />
  </div>
);

export const Bullet = ({ children }) => (
  <li className="relative pl-4 text-[13.5px] leading-relaxed text-[var(--text)] mb-1.5">
    <span className="absolute left-0 top-[9px] h-[5px] w-[5px] rounded-full bg-[var(--ink)]" />
    {children}
  </li>
);

export const SkillBar = ({ name, level, animate }) => (
  <div className="mb-4">
    <div className="flex items-center justify-between gap-2 mb-1.5">
      <span className="flex items-center gap-2">
        <span className="h-[5px] w-[5px] rounded-full bg-[var(--ink)]" />
        <span className="text-[13px] font-medium text-[var(--text)]">{name}</span>
      </span>
      <span className="text-[11px] font-semibold text-[var(--ink)] tabular-nums whitespace-nowrap">
        {level}<span className="text-[var(--muted)] font-normal">/10</span>
      </span>
    </div>
    <div className="relative h-[8px] w-full rounded-full bg-[var(--track)] overflow-hidden">
      <div
        className="h-full rounded-full bg-[var(--ink)] transition-[width] duration-1000 ease-out"
        style={{ width: animate ? `${level * 10}%` : "0%" }}
      />
      <div className="absolute inset-0 flex justify-between px-0 pointer-events-none">
        {TICK_POSITIONS.map((pos) => (
          <span
            key={`tick-${pos}`}
            className="w-px h-full bg-white/45"
            style={{ marginLeft: pos === 1 ? "10%" : 0 }}
          />
        ))}
      </div>
    </div>
  </div>
);

export const SkillScale = () => (
  <div className="mb-4">
    <div className="flex items-center justify-between text-[10px] text-[var(--muted)] mb-1">
      <span className="uppercase tracking-wider">Proficiency scale</span>
      <span>1 = Foundational · 10 = Expert</span>
    </div>
    <div className="relative">
      <div className="h-[6px] w-full rounded-full bg-gradient-to-r from-[var(--track)] to-[var(--ink)]" />
      <div className="flex justify-between mt-1">
        {SCALE_NUMBERS.map((n) => (
          <span
            key={`scale-${n}`}
            className="text-[9px] text-[var(--muted)] tabular-nums"
            style={{ width: "10%", textAlign: n === 1 ? "left" : n === 10 ? "right" : "center" }}
          >
            {n}
          </span>
        ))}
      </div>
    </div>
  </div>
);
